import { ColTypeDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { StatusCellRenderer } from 'routes/secondary-market-batch/grid/components/status-cell-renderer';
import { RowData } from 'state/workspaces/secondary-market/batch/model';

export function useStatusColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(() => {
    return {
      cellRenderer: StatusCellRenderer,
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
    };
  }, []);
}
